import config from '@/components/aem-core/experience-fragment/config';
import {
	Container,
	EditableComponent,
} from '@adobe/aem-react-editable-components';
import type { ContainerProps } from '@adobe/aem-react-editable-components';

const component = (props: ContainerProps) => (
	<EditableComponent config={config} {...props}>
		<Container {...props} />
	</EditableComponent>
);

export default component;
